import React from 'react';
import SIcon from './SIcon';
import { faToilet } from '@fortawesome/pro-solid-svg-icons';

const Icon = props => <SIcon {...props} icon={faToilet} fa />;

export default Icon;
